module.exports = __webpack_public_path__ + "static/media/Levin Fabric Chair_Grey.2a1c239f.png";